// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "scripts/" + chunkId + "." + {"367":"f4d34c869db1e5f162cb","579":"461aef77353cd9a66b61"}[chunkId] + ".js";
};